<div
  class="component-container text-cool-grey
        flex flex-col h-[100%] justify-center items-center
        p-[4rem] xs:p-[3.2rem] min-h-full"
>
  <div class="register-form-container md:w-[80%] w-full">
    <app-step-progress-indicator
      [currentStep]="1"
      [totalSteps]="5"
    ></app-step-progress-indicator>
    <div
      class="heading font-poppins font-bold mb-[2.4rem] flex justify-center text-center">
      {{ rolesLabelMap[userRole] }} Information
    </div>
    <form>
      <div
        class="row wrap-row flex xs:flex-col sm:flex-row w-full sm:gap-[2.4rem]">
        <app-text-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['firstName']"
          [maxLength]="validation.user.firstName.length.max"
          [minLength]="validation.user.firstName.length.min"
          [parentFormGroup]="form"
          class="input xs:w-full sm:w-1/2"
          controlName="firstName"
          label="First Name"
          placeholder="First Name"
          type="small"
        ></app-text-input>
        <app-text-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['lastName']"
          [maxLength]="validation.user.lastName.length.max"
          [minLength]="validation.user.lastName.length.min"
          [parentFormGroup]="form"
          class="input xs:w-full sm:w-1/2"
          controlName="lastName"
          label="Last Name"
          placeholder="Last Name"
          type="small"
        ></app-text-input>
      </div>
      <div
        class="row wrap-row flex xs:flex-col sm:flex-row w-full sm:gap-[2.4rem]">
        <app-date-picker
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['dob']"
          [max]="maxDobDate"
          [min]="minDobDate"
          [parentFormGroup]="form"
          class="input dob xs:w-full sm:w-1/2"
          controlName="dob"
          label="Date of Birth"
          placeholder="MM/DD/YYYY"
          type="small"
        ></app-date-picker>
        <app-dropdown
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['gender']"
          [options]="dropdownOptions"
          [parentFormGroup]="form"
          class="input gender xs:w-full sm:w-1/2 sm:min-w-[40%]"
          controlName="gender"
          label="Gender"
          placeholder="Select one"
          type="small"
        />
      </div>
      <div class="row email flex flex-row w-full gap-[2.4rem]">
        <app-text-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['email']"
          [maxLength]="validation.email.length.max"
          [parentFormGroup]="form"
          class="input w-full"
          controlName="email"
          label="Email"
          placeholder="user@mail.com"
          type="small"
          tooltipText="You may change your email in your profile once registration is complete."
        ></app-text-input>
      </div>
      <div class="flex flex-col w-full">
        <div class="flex flex-row w-full gap-[2rem] items-center mb-[0.3rem]">
          <app-text-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['username']"
            [maxLength]="null"
            [minLength]="validation.user.username.length.min"
            [ngClass]="{'hide': !displayErrorField,'show': !displayMessage}"
            [parentFormGroup]="form"
            [suffixIcon]="verificationStatusIcon"
            [tooltipText]="'Username cannot be changed after account registration.\n\nOnly lower case characters allowed.'"
            class="input username"
            controlName="username"
            label="Username"
            placeholder="Username"
            type="small"
            inputRestriction="noUpperCaseAlphabets"
          />
          <app-primary-button
            (handleClick)="verify()"
            [isDisabled]="!verifyUsername || inputUsername===generatedUsername || inputUsername == ''"
            [isLoading]="usernameStatusLoading"
            [ngClass]="{'hide': !displayErrorField, 'show': !displayMessage}"
            class="verify-btn mt-[0.5rem]"
          >
            Verify
          </app-primary-button>
        </div>
        <div class="flex w-full">
          <div
            *ngIf="displayMessage"
            class="row flex flex-row w-full gap-[2rem] justify-start items-center mb-[1rem]"
          >
            <div
              *ngIf="usernameStatusLoading; else loaded"
              class="loading text"
            >
              Loading...
            </div>
            <ng-template #loaded>
              <div
                *ngIf="isUsernameAvailable; else displayError"
                class="success flex flex-row justify-center items-center gap-[0.5rem]"
              >
                <app-icon
                  svgIcon="check-circle"
                ></app-icon>
                <div class="text">Username is available</div>
              </div>

              <ng-template #displayError>
                <div
                  class="error flex flex-row justify-center items-center gap-[0.5rem]"
                >
                  <app-icon
                    svgIcon="exclamation-circle"
                  ></app-icon>
                  <div class="text">Username is not available</div>
                </div>
              </ng-template>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="row flex flex-row w-full gap-[2.4rem]">
        <app-password-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['password']"
          [maxLength]="validation.password.length.max"
          [minLength]="validation.password.length.min"
          [parentFormGroup]="form"
          [tooltip]="true"
          class="input w-full"
          controlName="password"
          label="Password"
          placeholder="Password"
          type="small"
        ></app-password-input>
      </div>
      <div class="row flex flex-row w-full gap-[2.4rem]">
        <app-password-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['confirmPassword']"
          [maxLength]="validation.password.length.max"
          [minLength]="validation.password.length.min"
          [parentFormGroup]="form"
          class="input w-full"
          controlName="confirmPassword"
          label="Confirm Password"
          placeholder="Confirm Password"
          type="small"
        ></app-password-input>
      </div>
    </form>
    <div
      *ngIf="userRole === roles['participant']"
      class="row flex flex-col w-full"
    >
      <div class="avatar-heading mb-[0.8rem]">
        Select an avatar
      </div>
      <app-avatar-panel
        (handleClick)="selectAvatar($event)"
        class="justify-center items-center"
      ></app-avatar-panel>
    </div>
    <div class="action-section flex flex-col space-y-[2.4rem] items-center">
      <app-primary-button
        (handleClick)="register()"
        (handleKeypressEnter)="register()"
        [isDisabled]="!enableForm && !isUsernameAvailable "
        [isLoading]="registerLoading"
        class="register-btn w-[70%] flex justify-center"
      >
        REGISTER
      </app-primary-button>
    </div>
  </div>
</div>
